import { apiString as api } from '../../utils/constants';
import axios from 'axios';

export const fetchPopulations = async (id: string, isDisplayInAnalytic?: boolean) => {
    const response = await axios.get(`${api}/population/getpopulationsbyhealthplan?healthPlanId=${id}&isDisplayInAnalytic=${isDisplayInAnalytic}`);
    return response.data;
};